import { User, findUserByText } from "../../apis/mgmt/api";
import { DataViewProps, useStatefulDataView } from "../common/DataView";
import { FilteredPaginatedListLayout, useApiTextFilteredList } from "../common/FilteredPaginatedList";
import { ListProps, useStatefulList } from "../common/List";
import { Paginator, PagingProps, useStatefulPaging } from "../common/Paging";
import { SimpleTextFilter } from "../common/SimpleTextFilter";
import { UserSectionList } from "./UserList";

export const useUserFilteredPaginated = function () {

    const filterProps = useStatefulDataView('');
    const listProps = useStatefulList<User>();
    const pagingProps = useStatefulPaging();

    const result = useApiTextFilteredList<User>({
        filterProps: filterProps,
        listProps: listProps,
        pagingProps: pagingProps,
        apiQueryFunc: findUserByText
    });

    return {...result, listProps };
};

export const UserFilteredList = function (props:{
    filterProps: DataViewProps<string>,
    listProps: ListProps<User>,
    pagingProps: PagingProps
}) {

    const { filterProps, listProps, pagingProps} = props;
    
    return (
        <FilteredPaginatedListLayout
            filter={<SimpleTextFilter {...filterProps} />}
            list={<UserSectionList {...listProps} />}
            paginator={<Paginator {...pagingProps} />}
        />
    );

};
